// prettier-ignore
// This file is auto generated by bin/build-metadata.js

const illustrationsLogosByThemeMetadata = {
  "canvas": [
    "add-on-ads",
    "add-on-dedicated-ip",
    "add-on-lead-flows",
    "add-on-portal",
    "add-on-reporting",
    "add-on-ssl",
    "add-on-transactional-email",
    "add-on-website",
    "crm",
    "marketing-basic",
    "marketing-enterprise",
    "marketing-free",
    "marketing-pro",
    "marketing-starter",
    "sales-free",
    "training-academy",
    "training-crm",
    "training-growth-consulting",
    "training-inbound-campaign",
    "training-project-consulting",
    "training-sales-starter-kit",
    "training-technical-support",
    "cone",
    "pencil",
    "plus",
    "warning",
    "success-green",
    "lock",
    "errors/map",
    "errors/hourglass",
    "shoppingbag",
    "target",
    "mobile-onboarding-account-ready",
    "mobile-onboarding-connect-email",
    "mobile-onboarding-email-sent",
    "mobile-onboarding-embed-tracking-code",
    "mobile-onboarding-import-contacts",
    "mobile-onboarding-powering-up",
    "mobile-onboarding-welcome",
    "api",
    "campaigns",
    "design-manager",
    "empty-state-charts",
    "forms-success",
    "forms",
    "global",
    "idea",
    "note-widget",
    "product-library",
    "products-shopping-cart",
    "social",
    "success",
    "text-snippet",
    "unlock",
    "vote-and-search",
    "additional-hubspot-account-globe",
    "training-shop",
    "training-truck",
    "training-stand",
    "dedicated-ip-board",
    "dedicated-ip-briefcase",
    "designated-tech-support-laptop",
    "designated-tech-support-monitor",
    "designated-tech-support-ring",
    "hss-kit-book",
    "hss-kit-clipboard",
    "transactional-email-bars",
    "transactional-email-envelope",
    "transactional-email-web",
    "website-platform-laptop",
    "website-platform-mobile",
    "website-platform-monitor",
    "gift",
    "all-conversations-complete",
    "nps-question-thank-you",
    "nps-question",
    "no-conversations",
    "setup-complete",
    "successfully-submitted-question",
    "successfully-connected-email",
    "events",
    "keys",
    "knock-to-join",
    "open-door",
    "traffic-analytics",
    "transactions",
    "email-browser",
    "envelope-ring",
    "envelope-trio",
    "content-strategy",
    "deals",
    "leads",
    "predictive-lead-scoring",
    "sales-starter",
    "teams",
    "workflows",
    "sales-professional",
    "marketplace-module",
    "marketplace-single-template",
    "marketplace-template-pack",
    "announcement",
    "moving-truck",
    "qualify-leads",
    "copy-paste",
    "mobile-notify",
    "schedule",
    "successful-send",
    "email-sending-domain",
    "primary-hosting",
    "redirect-domain",
    "secondary-hosting",
    "store-disabled",
    "store",
    "calling",
    "documents",
    "meetings",
    "messages",
    "notifications",
    "sequences",
    "templates",
    "quotes",
    "beta",
    "calling-small",
    "integrations",
    "meetings-small",
    "social-connected",
    "design-principle-clear",
    "design-principle-collaborative",
    "design-principle-human",
    "design-principle-inbound",
    "design-principle-integrated",
    "marketing-templates",
    "task-queues",
    "conversation-tags",
    "task",
    "building",
    "components",
    "creating-ui-library",
    "documentation",
    "evergreen",
    "styles",
    "avatar-harvey",
    "avatar-hugo",
    "avatar-jane",
    "avatar-mariah",
    "avatar-michelle",
    "instagram-publish",
    "bolt",
    "import-file",
    "import-opt-out-list",
    "flowing-conversations",
    "conversations-inbox",
    "caution-connect-shared-email",
    "companies",
    "contacts",
    "deals-small",
    "robot-small",
    "robot",
    "knowledge-base",
    "service-hub-professional",
    "contacts-chat",
    "tickets",
    "categories",
    "ticket-small",
    "customer-experience",
    "customer-feedback",
    "customer-support",
    "business-hours",
    "sunny",
    "team-availability",
    "missed-goal",
    "categories-color",
    "trophy",
    "automated-testing",
    "email-forwarding",
    "team",
    "hss-extension",
    "conversation-assignment",
    "multiple-inboxes",
    "remove-branding",
    "segmented-lists",
    "account-security",
    "electronic-signature",
    "multiple-currency-revenue",
    "playbooks",
    "team-alignment",
    "sales-enterprise",
    "service-enterprise",
    "service-free",
    "service-professional",
    "service-starter",
    "calculated-properties",
    "success-quota-met",
    "import-multiple-association",
    "call-to-action",
    "ebook-download",
    "event-registration",
    "multiple-objects",
    "object",
    "registration",
    "crm-onboarding-add-contact",
    "crm-onboarding-integrations",
    "crm-onboarding-intro",
    "crm-onboarding-organized",
    "permission-sets",
    "social-monitoring",
    "connected-inboxes",
    "personalization-tokens",
    "marketplace-theme",
    "email-confirmation",
    "team-empty-state",
    "errors/general",
    "account-based-marketing",
    "electronic-signature-empty-state",
    "marketplace-solutions-directory",
    "custom-objects-button",
    "custom-objects-marketing",
    "custom-objects",
    "payments-button",
    "payments",
    "marketing-events-modal",
    "marketing-events",
    "developer-security-update",
    "calling-activity",
    "calling-dial",
    "calling-log",
    "calling-set-up",
    "forecasting",
    "record-data-density-modal",
    "settings-board-card",
    "settings-record-associations",
    "settings-record-creation",
    "settings-record-properties",
    "operations-custom-mappings",
    "add-on-multiple-domains-ssl",
    "add-on-wildcard-ssl",
    "calling-tracked-terms-empty-state",
    "calling-tracked-terms",
    "calling-transcript-empty-state",
    "calling-transcript",
    "credit-card-back",
    "credit-card-front",
    "simple-workflows",
    "sandbox-add-on",
    "payments-subscriptions",
    "marketplace-1000-apps",
    "association-labels",
    "associations",
    "operations-hub-data-sync",
    "operations-data-format",
    "calling-missed-call",
    "success-greyscale",
    "data-hosting-location",
    "settings-associations-cards",
    "settings-associations-table",
    "settings-data-highlights",
    "settings-properties-sidebar",
    "settings-sidebar",
    "settings-middle-pane-cards",
    "approvals",
    "reporting-customer-journey-analytics",
    "company-properties",
    "contact-properties",
    "crm-migrations-bot",
    "deal-pipeline-properties",
    "deal-properties",
    "general-object-properties",
    "product-properties",
    "delete-custom-object-cases",
    "tickets-to-cases-sync",
    "crm-conditional-logic",
    "mobile-social-publishing",
    "settings-crm-table-view",
    "invoice-properties",
    "invoices",
    "coaching-playlists-empty-state",
    "coaching-playlists-recordings-empty-state",
    "coaching-playlists",
    "email-empty-state-high-performing",
    "email-empty-state-low-performing",
    "workflow-branch-action-outcome",
    "workflow-branch-filter-criteria",
    "workflow-branch-property-value",
    "content-assistant-highlight-tip",
    "content-assistant-highlight",
    "content-assistant-slash-tip",
    "content-assistant-slash",
    "carts",
    "orders",
    "crm-associations-label-pivot-card",
    "crm-associations-table-card",
    "crm-custom-dev-card",
    "crm-data-highlights-card",
    "crm-hubspot-standard-card",
    "crm-integrations-card",
    "crm-properties-card",
    "crm-reporting-card",
    "crm-social-contact-match",
    "deal-pipeline-rules",
    "conversational-assistant",
    "forecasting-ai",
    "hubspot-ai",
    "empty-state-associations",
    "empty-state-companies",
    "workflow-branch-percentage",
    "sales-customize-preview-sidebar",
    "artificial-intelligence-core",
    "artificial-intelligence-enhanced",
    "crm-activities-card",
    "signal-bars-high",
    "signal-bars-low",
    "signal-bars-medium",
    "crm-playbooks-card",
    "content-remix",
    "audiences",
    "crm-card-library",
    "breeze-ai",
    "buyer-intent",
    "case-studies",
    "enrichment",
    "form-shortening",
    "service-object",
    "settings-crm-insights-card",
    "empty-state-no-data",
    "facebook-messenger",
    "google-adwords",
    "google-gmail",
    "google",
    "hubspot-wordmark--light",
    "hubspot-wordmark",
    "office-365",
    "outlook",
    "rivaliq",
    "salesforce",
    "shopify",
    "slack-wordmark",
    "slack-wordmark--light",
    "slack",
    "stripe-wordmark",
    "stripe",
    "google-groups",
    "facebook",
    "google-ads",
    "linkedin",
    "wordpress",
    "google-chrome",
    "twilio",
    "zoom",
    "plaid",
    "databox",
    "google-data-studio",
    "google-sheets",
    "google-slides",
    "youtube",
    "whatsapp",
    "exchange",
    "mailchimp",
    "pipedrive",
    "zoho-crm",
    "quickbooks",
    "godaddy",
    "instagram",
    "onlydomains-stacked",
    "onlydomains",
    "stripe-wordmark-blurple",
    "x-social",
    "breeze-copilot-logotype-vertical-gradient",
    "breeze-logotype-horizontal-black",
    "breeze-logotype-horizontal-gradient",
    "breeze-logotype-vertical-black",
    "breeze-logotype-vertical-gradient",
    "breeze-symbol-gradient",
    "amplitude",
    "tiktok",
    "bing",
    "reddit",
    "apple",
    "microsoft",
    "meta-logo",
    "meta-wordmark",
    "google-calendar",
    "google-maps",
    "google-play",
    "microsoft-logo",
    "amex",
    "apple-pay",
    "diners-club",
    "discover",
    "google-pay",
    "japan-card-bureau",
    "mastercard",
    "visa",
    "google-meet",
    "threads-wordmark",
    "klarna-wordmark",
    "affirm-wordmark",
    "openaiblossom",
    "openaichatgptads"
  ],
  "trellis": [
    "account-based-marketing",
    "avatar-harvey",
    "avatar-hugo",
    "avatar-jane",
    "avatar-mariah",
    "avatar-michelle",
    "manage-relationships",
    "operations-hub-data-sync",
    "personalization-index",
    "success-green",
    "success-greyscale",
    "success-quota-met",
    "success",
    "successful-send",
    "successfully-submitted-question",
    "sunny",
    "target",
    "task-queues",
    "task",
    "welcome",
    "service-enterprise",
    "service-free",
    "service-hub-professional",
    "service-professional",
    "service-starter",
    "sales-enterprise",
    "sales-free",
    "sales-professional",
    "sales-starter",
    "training-sales-starter-kit",
    "content-strategy",
    "payments-button",
    "payments-subscriptions",
    "payments",
    "calling-activity",
    "calling-dial",
    "calling-log",
    "calling-missed-call",
    "calling-set-up",
    "calling-small",
    "calling",
    "all-conversations-complete",
    "bolt",
    "empty-state-charts",
    "empty-state-records",
    "marketing-basic",
    "marketing-enterprise",
    "marketing-free",
    "marketing-pro",
    "marketing-starter",
    "add-on-ads",
    "add-on-dedicated-ip",
    "add-on-lead-flows",
    "add-on-multiple-domains-ssl",
    "add-on-portal",
    "add-on-reporting",
    "add-on-ssl",
    "add-on-transactional-email",
    "add-on-website",
    "add-on-wildcard-ssl",
    "association-labels",
    "associations",
    "carts",
    "crm-activities-card",
    "crm-associations-label-pivot-card",
    "crm-associations-table-card",
    "crm-card-library",
    "crm-custom-dev-card",
    "crm-data-highlights-card",
    "crm-hubspot-standard-card",
    "crm-integrations-card",
    "crm-onboarding-integrations",
    "crm-playbooks-card",
    "crm-properties-card",
    "crm-reporting-card",
    "crm",
    "customer-experience",
    "customer-feedback",
    "customer-support",
    "deal-pipeline-properties",
    "deal-properties",
    "deals-small",
    "deals",
    "dedicated-ip-briefcase",
    "integrations",
    "product-library",
    "product-properties",
    "products-shopping-cart",
    "ticket-small",
    "tickets-to-cases-sync",
    "tickets",
    "account-security",
    "announcement",
    "api",
    "approvals",
    "audiences",
    "beta",
    "companies",
    "company-properties",
    "cone",
    "connected-inboxes",
    "contact-properties",
    "contacts",
    "social-connected",
    "successfully-connected-email",
    "contacts-chat",
    "conversation-assignment",
    "email-confirmation",
    "forms",
    "greeting-afternoon",
    "greeting-evening",
    "greeting-morning",
    "errors/general",
    "errors/map",
    "agent-core-avatar"
  ]
} as const;

export type IllustrationLogoNamesByTheme =
  keyof typeof illustrationsLogosByThemeMetadata;
export default illustrationsLogosByThemeMetadata;
